/* eslint-disable @typescript-eslint/no-explicit-any */
export const getWidgetBus = (): any => {
  const widgetConfiguration = (window as any).SGWTWidgetConfiguration;
  return widgetConfiguration && widgetConfiguration.bus ? widgetConfiguration.bus : null;
};
